import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Head, JsonLdScript, renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { TrustpilotWidget, Wrapper, TrustpilotWidgetTemplates } from "@cinch-nx/shared-ui";
import { useViewport } from "@cinch-labs/shared-util";
import { StoreIntro, HowItWorks } from "./components";
import styles from "./landing-feature-store-page.module.css";
import { StoreDetailsWrapper } from "./components/store-details-wrapper";
import { StoreFaqs } from "./components/store-faqs";
import { capitaliseFirstLetter } from "./utils/capitalise-first-letter";
import { generateFallbackDescription, generateFallbackTitle } from "./data/landing-store-feature.data";
import { VehiclesInStock } from "./components/vehicles-in-stock/vehicles-in-stock";
import { formatStoreToSchema } from "libs/landing/ui/shared/src/lib/json-ld-script/helpers/structured-data";
import { WhyCinch } from "./components/why-cinch";
import cx from "classnames";
export function LandingFeatureStorePage(param) {
    var story = param.story, generatedAt = param.generatedAt, preview = param.preview, storeVehicles = param.storeVehicles;
    var ref, ref1, ref2;
    var vw = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    }).vw;
    var isMobile = vw < 1024;
    var shouldShowCarousel = (isMobile || storeVehicles.length > 2) && storeVehicles.length > 0;
    var content = useStoryblokState({
        story: story,
        enableBridge: preview
    }).content;
    var storeIntro = content.storeIntro, storeHowCinchWorksComponent = content.storeHowCinchWorksComponent, storeFAQSection = content.storeFAQSection, mapInformation = content.mapInformation, address = content.address, phoneNumbers = content.phoneNumbers, openingHoursList = content.openingHoursList, storeHero = content.storeHero, storeWhyBuy = content.storeWhyBuy;
    var SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    var storeIntroTitle = storeIntro[0].title;
    var storeIntroText = renderWithResolver(storeIntro[0].body);
    var howItWorksTitle = storeHowCinchWorksComponent[0].title;
    var howCinchWorksList = storeHowCinchWorksComponent[0].howCinchWorksList;
    var ref3 = storeWhyBuy[0], whyBuyContent = ref3.titleAndText;
    var storeSlug = story.slug;
    var storeName = capitaliseFirstLetter(storeSlug);
    var _address = _sliced_to_array(address, 1), storeAddress = _address[0];
    var storeImageUrl = storeHero[0].image.filename;
    var ref4 = storeFAQSection[0], faqTitle = ref4.title, faqs = ref4.faqs;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(JsonLdScript, {
                schema: formatStoreToSchema({
                    storeSlug: storeSlug,
                    storeAddress: storeAddress,
                    mapInformation: mapInformation,
                    phoneNumbers: phoneNumbers,
                    openingHoursList: openingHoursList,
                    storeImageUrl: storeImageUrl
                }),
                tagId: "automotive business"
            }),
            /*#__PURE__*/ _jsx(Head, _object_spread_props(_object_spread({}, SEO), {
                generatedAt: generatedAt,
                fallbackTitle: generateFallbackTitle(storeName),
                fallbackDescription: generateFallbackDescription(storeName)
            })),
            /*#__PURE__*/ _jsxs("article", {
                className: styles.root,
                children: [
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.storeWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(StoreIntro, {
                            title: storeIntroTitle,
                            introText: storeIntroText,
                            slug: storeSlug
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        backgroundColor: "#f2f5ff",
                        className: {
                            container: styles.howItWorksWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(HowItWorks, {
                            title: howItWorksTitle,
                            howCinchWorksList: howCinchWorksList,
                            slug: storeSlug
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        backgroundColor: "#F9F9F9",
                        className: {
                            inner: styles.trustpilotWrapper
                        },
                        children: /*#__PURE__*/ _jsx(TrustpilotWidget, {
                            height: "24px",
                            widget: isMobile ? TrustpilotWidgetTemplates.microStar : TrustpilotWidgetTemplates.microCombo
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.storeWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(StoreDetailsWrapper, {
                            slug: storeName,
                            latitude: Number.parseFloat((ref1 = mapInformation[0]) === null || ref1 === void 0 ? void 0 : ref1.latitude),
                            longitude: Number.parseFloat((ref2 = mapInformation[0]) === null || ref2 === void 0 ? void 0 : ref2.longitude),
                            address: storeAddress,
                            phoneNumbers: phoneNumbers,
                            openingHours: openingHoursList
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.storeWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(StoreFaqs, {
                            title: faqTitle,
                            faqs: faqs
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        backgroundColor: "#f8f6ff",
                        className: {
                            container: cx(styles.storeWrapper, styles.whyCinchWrapper),
                            inner: styles.storeWrapperInner
                        },
                        children: /*#__PURE__*/ _jsx(WhyCinch, {
                            whyBuyContent: whyBuyContent
                        })
                    }),
                    shouldShowCarousel && /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.storeWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(VehiclesInStock, {
                            slug: storeSlug,
                            vehicles: storeVehicles
                        })
                    })
                ]
            })
        ]
    });
}
export default LandingFeatureStorePage;
